import { useGroupsContext } from '@fs/zion-tree-groups'
import Subnav from '@fs/zion-tree-subnav-legacy'
import { colors } from '@fs/zion-ui'
import React from 'react'
import { useLocation } from '@fs/zion-router'

export function SubnavWrapper() {
  const { groups, currentTreeId, selectTree } = useGroupsContext()
  const { pathname } = useLocation()
  const page = pathname.substr?.(1)?.split('/')?.[0]

  return (
    <div style={{ borderBottom: `1px solid ${colors.gray10}` }}>
      <Subnav
        page={page || 'family'}
        onTreeNavClickOverride={(treeId) => {
          const groupToGoTo = groups?.find((group) => group.treeIds?.[0] === treeId)
          if ((treeId === 'PRIVATE' && currentTreeId === '') || (groupToGoTo && pathname.includes(groupToGoTo.id))) {
            return
          }

          if (treeId === 'PRIVATE') {
            window.location.assign('/tree/pedigree/?treeId=PRIVATE')
          } else if (groupToGoTo) {
            selectTree?.(treeId)
            window.location.assign(
              `/groups/${groupToGoTo.types.includes('RESEARCHER_TREE') ? 'research-tree' : 'family'}/${groupToGoTo.id}`
            )
          }
        }}
      />
    </div>
  )
}
